export default "__VITE_ASSET__CdRcNWob__"